import { useState } from 'react';
import {
    Container,
    Typography,
    Box,
    Accordion,
    AccordionDetails,
    AccordionSummary
} from '@mui/material';
import { theme } from '../../../theme/theme';
import { useTranslation } from 'react-i18next';
import { FAQ } from '../../../constants/FAQ';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQSection = () => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Box
            component="section"
            sx={{
                width: '100%',
                backgroundColor: theme.palette.background.lightBlue,
                pt: 8,
                pb: 2,
            }}
        >
            <Container
                maxWidth="md"
                sx={{
                    [theme.breakpoints.down('sm')]: {
                        px: 2,
                    },
                }}
            >
                <Typography
                    variant="h4"
                    component="h1"
                    fontWeight={700}
                    fontSize="35px"
                    align="center"
                    gutterBottom
                    sx={{ mb: 4 }}
                >
                    {t('FAQ')}
                </Typography>

                <Box component="div" display="flex" flexDirection="column" gap={4}>
                    {FAQ.map((section, sectionIndex) => (
                        <Box key={sectionIndex} component="section">
                            <Typography
                                component="p"
                                fontWeight={700}
                                fontSize="22px"
                                sx={{
                                    mb: 2,
                                    color: theme.palette.text.primary,
                                }}
                            >
                                {section.title}
                            </Typography>

                            {section.questions.map((q, questionIndex) => {
                                const panelId = `panel-${sectionIndex}-${questionIndex}`;
                                return (
                                    <Accordion
                                        key={panelId}
                                        expanded={expanded === panelId}
                                        onChange={handleChange(panelId)}
                                        sx={{
                                            border:'1px solid #7e9eff70',
                                            marginBottom:'4px',
                                            boxShadow: 'none',
                                            '&:before': {
                                                display: 'none',
                                            },
                                        }}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: '#3356D4' }} />}
                                            aria-controls={`${panelId}-content`}
                                            id={`${panelId}-header`}
                                        >
                                            <Typography sx={{color:'#1f2d5c'}}>{q.question}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            <Typography>{q.answer}</Typography>

                                            {q.solution && (
                                                <Typography sx={{ mt: 1, fontStyle: 'italic' }}>
                                                    {q.solution}
                                                </Typography>
                                            )}

                                            {q.options && Array.isArray(q.options) && (
                                                <Box component="ul" sx={{ pl: 3, mt: 1 }}>
                                                    {q.options.map((opt, idx) => (
                                                        <li key={idx}>
                                                            <Typography>
                                                                <strong>{opt.title}</strong>{opt.text}
                                                            </Typography>
                                                        </li>
                                                    ))}
                                                </Box>
                                            )}
                                        </AccordionDetails>
                                    </Accordion>
                                );
                            })}
                        </Box>
                    ))}
                </Box>
            </Container>
        </Box>
    );
};

export default FAQSection;
